import { Sexo } from "../enums/sexo";
import { TipoPessoa } from "../enums/tipoPessoa";
import { TipoPreco } from "../enums/tipoPreco";

export class Cliente {
  id:  number | null = null;
  ativo?: boolean | null = true;
  nome: string = '';
  razaoSocial: string = '';
  cpfCnpj: string | null = null;
  tipoPessoa: TipoPessoa = TipoPessoa.FISICA;
  rgIE: string = '';
  endereco: string = '';
  numero: string = '';
  bairro: string = '';
  cep: string = '';
  cidade: string = '';
  estado: string = '';
  telefone: string = '';
  celular: string = '';
  dataCadastro: string = '';
  email: string = '';
  contato: string = '';
  sexo: Sexo | null = null;
  tipoPreco: TipoPreco = TipoPreco.VAREJO;
  dataUltimaModificacao: string | null = null;
  empresaId?: string; // UUID da empresa (tenant) - para validação de segurança
}
